// extracted by mini-css-extract-plugin
export default {"management_panel":"ManagementPanel_management_panel__87J9B","icon_button":"ManagementPanel_icon_button__MiaRH","shimmer":"ManagementPanel_shimmer__4GiXR"};